<template>
	<el-main>
		<MceBanner />
		<CoreFunction/>
		<DataService :data="dataService" />
	</el-main>
</template>

<script>
  import MceBanner from './MceBanner'
	import CoreFunction from './CoreFunction'
	import DataService from './DataService'
	export default {
		name: 'PortalMCE',
		components: {
      MceBanner,
			CoreFunction,
			DataService
		},
		data() {
			return {
				dataimgs: [{
					id: 0,
					src1: require('@/assets/images/banner1.jpg'),
					src2: require('@/assets/images/banner1-m.png'),
					title: '容器云平台',
					content: ['整合容器技术，提供高可用的应用托管和数据库服务', '并覆盖DevOps全域管理'],
					btn: '立即体验',
					url: '#',
					platform:'感谢关注MoPaaS容器云平台，平台暂未开放公有云服务，如需试用，请联系客服。'
				}],
				dataService: [{
					id: 0,
					src: require('@/assets/images/heart.png'),
					title: '服务客户',
					content: '100+'
				}, {
					id: 1,
					src: require('@/assets/images/shield.png'),
					title: '可靠性',
					content: '99.99%'
				}, {
					id: 2,
					src: require('@/assets/images/customer.png'),
					title: '服务政策',
					content: '7X24小时服务'
				}]
			}
		}
	}
</script>

<style>

</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalMCE.vue